import InputAdornment from "@mui/material/InputAdornment";
import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { getACDetail } from "src/apis/System/accessControl.api";
import { validationAccessControlInput } from "src/utils";
import useForm, { Form } from "src/hooks/useForm";
import Controls from "src/components/form/controls/Controls";

const initialValue = {
  id: "",
  name: "",
  route: "",
  childRoute: "",
  icon: "",
  parentId: "",
  permissionIds: [],
  permissionAction: [],
  permissionUpdate: [],
};

const permissionOptions = [
  {
    name: "Create",
    id: "create",
  },
  {
    name: "Read",
    id: "read",
  },
  {
    name: "Update",
    id: "update",
  },
  {
    name: "Delete",
    id: "delete",
  },
];

const PermissionCRUDFormTableHead = ["name", "Slug", "description"];

const renderHead = (item, index) => <th key={index}>{item}</th>;

const renderBody = (permission, name, index) => (
  <tr key={index}>
    <td>{`${permission} ${name}`}</td>
    <td>{`${permission}-${name}`}</td>
    <td>{`Allow a User to ${permission.toLowerCase()} a ${name}`}</td>
  </tr>
);

const AccessControlForm = (props) => {
  const {
    parentRoute,
    parentRouteId,
    recordForEdit,
    addOrEdit,
    isSubRoute,
    errorsForm,
  } = props;

  initialValue.parentId = parentRouteId ? parentRouteId : null;

  // validation input employee
  const validateAccessControlForm = (fieldValues = values) => {
    let temp = validationAccessControlInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateAccessControlForm);

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (parentRouteId) {
      getACDetail(parentRouteId, (result) => {
        initialValue.permissionIds = result.permissions.map(
          (permission) => permission.id
        );
      });
    }
  }, [parentRouteId]);

  useEffect(() => {
    if (recordForEdit !== null) {
      // * push active permissionIds of role
      recordForEdit.permissionIds = recordForEdit.permissions.map(
        (permissions) => permissions.id
      );

      // * handle checked permission when show form update
      const permissionAction = [];
      for (const permission of recordForEdit.permissions) {
        if (permission.name.includes("CREATE")) {
          permissionAction.push("create");
        }
        if (permission.name.includes("READ")) {
          permissionAction.push("read");
        }
        if (permission.name.includes("UPDATE")) {
          permissionAction.push("update");
        }
        if (permission.name.includes("DELETE")) {
          permissionAction.push("delete");
        }
      }

      setValues((prev) => {
        return {
          ...prev,
          ...recordForEdit,
          permissionAction,
        };
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateAccessControlForm()) {
      if (!parentRoute) {
        if (recordForEdit !== null) {
          values.childRoute = `${values.route}`;
        } else {
          values.childRoute = `/${values.route}`;
        }
      }

      if (parentRoute && !isSubRoute) {
        values.childRoute = `${parentRoute}/${values.route}`;
      }

      if (parentRoute && isSubRoute) {
        values.childRoute = `${values.route}`;
      }

      addOrEdit(values, resetForm);
    }
  };
  const checkRenderAndSubmit = () => {
    return values.route && values.name;
  };
  return (
    <Form
      onSubmit={onSubmit}
      style={{
        backgroundColor: "var(--main-bg)",
        padding: "20px",
        borderRadius: "10px",
      }}
    >
      <Controls.Input
        name="name"
        value={values.name}
        label="Name"
        type="text"
        onChange={handleInputChange}
        error={errors.name}
      />
      {recordForEdit ? (
        <Controls.Input
          name="route"
          value={values.route}
          label="Route"
          type="text"
          onChange={handleInputChange}
          error={errors.route}
        />
      ) : (
        <Controls.Input
          InputProps={{
            style: { color: "var(--txt-color)" },
            startAdornment: parentRoute ? (
              <InputAdornment position="start">
                {parentRoute + "/"}
              </InputAdornment>
            ) : (
              <InputAdornment position="start">
                {"/" + parentRoute}
              </InputAdornment>
            ),
          }}
          name="route"
          value={values.route}
          label="Route"
          type="text"
          onChange={handleInputChange}
          error={errors.route}
        />
      )}

      <Controls.Input
        name="icon"
        value={values.icon}
        label="Icon"
        type="text"
        onChange={handleInputChange}
      />

      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Controls.MultipleCheckbox
            name="permissionAction"
            label="Action"
            value={values.permissionAction}
            onChange={handleInputChange}
            options={permissionOptions}
          />
        </Grid>
        <Grid item xs={8}>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card__body">
                  <div className="table-wrapper">
                    <table>
                      {PermissionCRUDFormTableHead && renderHead ? (
                        <thead>
                          <tr>
                            {PermissionCRUDFormTableHead.map((item, index) =>
                              renderHead(item, index)
                            )}
                          </tr>
                        </thead>
                      ) : null}
                      <tbody>
                        {checkRenderAndSubmit()
                          ? values.permissionAction.map((permission, index) =>
                              renderBody(permission, values.name, index)
                            )
                          : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
      <Controls.Input
        name="parentId"
        value={parentRouteId}
        type="hidden"
        label="ParentId"
        sx={{ display: "none" }}
      />
      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={checkRenderAndSubmit() ? false : true}
      />
    </Form>
  );
};

export default AccessControlForm;
